import { g as getNodeName } from './getNodeName-B4zdFol3.js';

function isTableElement(element) {
  return ['table', 'td', 'th'].indexOf(getNodeName(element)) >= 0;
}

export { isTableElement as i };
//# sourceMappingURL=isTableElement-xhzaNsSK.js.map
